import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const ImageSlider = ({ blok }) => {
/*   console.log("test", blok.blockSLider); */
  return (
    <div className="instagram-content-outer" {...storyblokEditable(blok)}>
        {blok.picture.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
    </div>
  );
};

export default ImageSlider;
